"use client";

import { useSyncExternalStore } from "react";

const dismissKey = "evilla-event-banner-dismissed";
const changeEvent = "evilla-event-banner-change";

function subscribe(onStoreChange: () => void) {
  window.addEventListener(changeEvent, onStoreChange);
  return () => window.removeEventListener(changeEvent, onStoreChange);
}

function getDismissed() {
  return sessionStorage.getItem(dismissKey) === "true";
}

function getServerDismissed() {
  return false;
}

function updateDismissed(dismissed: boolean) {
  if (dismissed) {
    sessionStorage.setItem(dismissKey, "true");
  } else {
    sessionStorage.removeItem(dismissKey);
  }
  window.dispatchEvent(new Event(changeEvent));
}

export function EventBanner() {
  const dismissed = useSyncExternalStore(subscribe, getDismissed, getServerDismissed);

  function closeBanner() {
    updateDismissed(true);
  }

  function reopenBanner() {
    updateDismissed(false);
  }

  if (dismissed) {
    return (
      <button
        type="button"
        className="event-banner-reopen"
        onClick={reopenBanner}
        aria-label="Open informatie over Beurs Eigen Huis en de open dagen"
      >
        Beurs &amp; open dagen
      </button>
    );
  }

  return (
    <aside className="event-banner" role="complementary" aria-label="Evenementen en open dagen">
      <div className="shell event-banner-inner">
        <div className="event-banner-items">
          <div className="event-banner-item">
            <span className="event-chip">Beurs</span>
            <span>
              <strong>Beurs Eigen Huis</strong>, 9 tot en met 11 oktober, Jaarbeurs Utrecht.
              Kom langs, we hebben gratis kaarten.
            </span>
            <a href="/start" className="event-link">Vraag gratis kaarten aan</a>
          </div>
          <div className="event-banner-item">
            <span className="event-chip">Open dag</span>
            <span>
              <strong>Open dagen in Apeldoorn</strong>, september tot en met november.
              Loop mee door een huis dat nog in aanbouw is. Alleen op afspraak.
            </span>
            <a href="/start" className="event-link">Meld je aan</a>
          </div>
        </div>
        <button
          className="event-banner-close"
          onClick={closeBanner}
          aria-label="Sluit evenementenbalk"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
    </aside>
  );
}